import { axios } from './axios';

import { BufferBag } from '@/pages/types';

export const getBufferBags = async ({ orderId }: { orderId?: string }) => {
  return axios
    .get<BufferBag[]>('/buffer_bags', {
      params: {
        order_id: orderId,
      },
    })
    .then((res) => res.data);
};
